import { CSSObject, SerializedStyles } from '@emotion/react';
import { ReactNode } from 'react';
import { DefaultAppRoute, LinkRouterProps } from '@anytag/router';
import { Anchor } from '@anytag/shared-atoms';
import { Logo } from '@anytag/shared-molecules';
import { cn } from '@anytag/shared-utils';

const headerRoutes = ['/sign-in', '/sign-up'] as const satisfies LinkRouterProps['to'][];
export interface SignInSignUpHeaderProps {
  to?: (typeof headerRoutes)[number] | DefaultAppRoute;
  className?: string | CSSObject | SerializedStyles;
  signLink?: { description?: ReactNode; title?: ReactNode; to?: (typeof headerRoutes)[number] };
}

export const SignInSignUpHeader = ({ to, signLink, className }: SignInSignUpHeaderProps) => (
  <div className={cn('flex w-[var(--dashboard-max-width)] items-center justify-between pb-4', className)}>
    <Logo type="black" to={to} className="h-8 max-w-46.5" />

    {signLink ? (
      <div className="flex self-end text-center text-md leading-4 font-normal">
        {signLink.description}
        <Anchor className="ml-2 text-md leading-4 font-stretch-normal hover:opacity-80" variant="blue" to={signLink.to}>
          {signLink.title}
        </Anchor>
      </div>
    ) : null}
  </div>
);
